import Axios, { AxiosInstance } from 'axios';

export class HttpService {
    public axios: AxiosInstance;
    constructor() {
    this.axios = Axios.create();
    }
}

const instance = new HttpService();
export default instance;
